"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_1 = __importDefault(require("react"));
var PopupText_1 = __importDefault(require("atomicComponents/molecules/Tooltips/PopupText"));
var SubtleTextField_1 = __importDefault(require("containers/TeamView/styles/SubtleTextField"));
var eventHandlers_1 = require("utils/form/eventHandlers");
var hooks_1 = require("utils/hooks");
var cleanNum = function (v) {
    if (!v)
        return v !== null && v !== void 0 ? v : '';
    var vAfterFirstClean = v.replace(/[^\d.]/g, '');
    var multiDotMatch = vAfterFirstClean.match(/^(\d*\.)(\d*\..+)/);
    if (multiDotMatch) {
        return "".concat(multiDotMatch[1]).concat(multiDotMatch[2].replace(/\./g, ''));
    }
    return vAfterFirstClean;
};
var makeNumberField = function (_a) {
    var collection = _a.collection, setter = _a.setter, getter = _a.getter, idGetter = _a.idGetter, noEditCondition = _a.noEditCondition, disableCondition = _a.disableCondition;
    return function (_a) {
        var _b, _c;
        var item = _a.item;
        var _d = __read(react_1.default.useState(false), 2), isActive = _d[0], setIsActive = _d[1];
        var _e = __read((0, hooks_1.useSubmitter)(collection, (_b = idGetter === null || idGetter === void 0 ? void 0 : idGetter(item)) !== null && _b !== void 0 ? _b : item.id), 1), itemSubmitter = _e[0];
        var currentValue = getter(item);
        var _f = __read(react_1.default.useState((_c = currentValue === null || currentValue === void 0 ? void 0 : currentValue.toString()) !== null && _c !== void 0 ? _c : ''), 2), value = _f[0], setValue = _f[1];
        var setInputActive = function (isActiveNow) {
            setIsActive(isActiveNow);
            // onInputActive?.(isActiveNow);
        };
        var handleClose = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!value) return [3 /*break*/, 2];
                        return [4 /*yield*/, itemSubmitter(setter(+value, item))];
                    case 1:
                        _a.sent();
                        setInputActive(false);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        react_1.default.useEffect(function () {
            var _a;
            if (currentValue !== value && !isActive)
                setValue((_a = currentValue === null || currentValue === void 0 ? void 0 : currentValue.toString()) !== null && _a !== void 0 ? _a : '');
        }, [currentValue]);
        var handleChange = function (e) { return setValue(cleanNum(e.target.value)); };
        var TextFieldComponent = SubtleTextField_1.default;
        if (noEditCondition === null || noEditCondition === void 0 ? void 0 : noEditCondition(item)) {
            return (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ width: 1 }, { children: (0, jsx_runtime_1.jsx)(PopupText_1.default, { message: currentValue }) }));
        }
        return ((0, jsx_runtime_1.jsx)(TextFieldComponent, { style: { width: '100%' }, type: "text", disabled: disableCondition === null || disableCondition === void 0 ? void 0 : disableCondition(item), onChange: handleChange, onFocus: function () { return setInputActive(true); }, onClick: function () { return setInputActive(true); }, onKeyPress: (0, eventHandlers_1.onHitEnter)(handleClose), onBlur: handleClose, 
            // variant={(label ? 'outlined' : 'standard') as any}
            variant: 'standard', value: value, InputProps: {
                disableUnderline: true,
                autoComplete: 'off',
                inputProps: {
                    style: { textAlign: 'left', paddingRight: 8 },
                },
            } }));
    };
};
exports.default = makeNumberField;
